import { MapContainer, TileLayer, Marker } from "react-leaflet";
import { Icon } from "leaflet";
import { Addresses } from "utils/Addresses";
import React, { useState, useRef, useMemo } from "react";

export const defaultLocation = {
  lat: 35.74845403677684,
  lng: 51.41355872154236,
};

export interface defaultLocationType {
  lat: number;
  lng: number;
}

interface Props {
  height?: string;
  changeMarker: (location: any) => void;
  location: defaultLocationType;
}

const Map: React.FC<Props> = ({ height, changeMarker, location }) => {
  function DraggableMarker() {
    const [draggable, setDraggable] = useState(true);
    const markerRef = useRef(null);

    const eventHandlers = useMemo(
      () => ({
        dragend() {
          const marker: any = markerRef.current;
          if (marker != null) {
            changeMarker(marker.getLatLng());
          }
        },
      }),
      []
    );

    return (
      <Marker
        icon={
          new Icon({
            iconUrl: Addresses.images.MAP_MARKER,
            iconSize: [25, 41],
            iconAnchor: [12, 41],
          })
        }
        draggable={draggable}
        eventHandlers={eventHandlers}
        position={location}
        ref={markerRef}
      ></Marker>
    );
  }

  return (
    <div style={{ width: "100%" }}>
      <MapContainer
        center={location}
        zoom={12}
        scrollWheelZoom={false}
        style={{
          width: "100%",
          height: height !== undefined ? height : "400px",
        }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <DraggableMarker />
      </MapContainer>
    </div>
  );
};

export default Map;
